<div class="rating">
  <!-- rate image -->
  <img
    [src]="'../../../../../../assets/images/' + (rate >= 4 ? 'rating-face-good.svg' : rate >= 2 ? 'rating-face-medium.svg' : 'rating-face-bad.svg')"
    [alt]="rate"
  />

  <!-- rate -->
  <div class="rate">
    <span>Rate</span>
    <span>{{5 | numberFormat }}/{{rate ?? 0 | numberFormat}}</span>
  </div>
</div>
